import React from 'react'
import { List, ListItem, Typography } from '@mui/material'

import { withStyles } from 'tss-react/mui'
import styles from './EcoModeDevicesList.style'
import EcoModeDevice from './EcoModeDevice'

interface Props {
  classes: Record<string, string>,
  admin: boolean,
  ecoModeDevices: any[],
  selectCurrentEcoModeDeviceId: (id: number) => void,
  selectCurrentEcoModeDeviceStatus: (status: boolean) => void,
  patchCurrentEcoModeDevice: (...args: any[]) => void,
}

class EcoModeDevicesList extends React.Component<Props> {
  render() {
    const {
      classes,
      ecoModeDevices,
      selectCurrentEcoModeDeviceId,
      selectCurrentEcoModeDeviceStatus,
      patchCurrentEcoModeDevice,
      admin,
    } = this.props
    return (
      <List className={classes.root}>
        {ecoModeDevices.length
          ? ecoModeDevices.map((device) => (
            <ListItem
              key={device.id}
              className={classes.listItem}
            >
              <EcoModeDevice
                className={classes.deviceItem}
                id={device.id}
                admin={admin}
                icon={device.icon}
                name={device.name}
                ecoModeStatus={device.eco_mode}
                selectCurrentEcoModeDeviceId={selectCurrentEcoModeDeviceId}
                selectCurrentEcoModeDeviceStatus={selectCurrentEcoModeDeviceStatus}
                patchCurrentEcoModeDevice={patchCurrentEcoModeDevice}
              />
            </ListItem>
          )) : <Typography align="center" variant="h6">{I18n.t('my_energy.no_devices')}</Typography>}
      </List>
    )
  }
}

export default withStyles(EcoModeDevicesList, styles as any) as unknown as React.ComponentType<Omit<Props, 'classes'>>
